import api from './../../Axios'; // Adjust path to your Axios instance

// Define the payload interface to match your Backend DTO
export interface LawyerFinalStepPayload {
  expertCode: string;
  isAgreementSigned: boolean;
  isAcknowledged: boolean;
}

// 🟢 STEP 3: FINAL SUBMISSION API
export const submitLawyerOnboarding = async (data: LawyerFinalStepPayload) => {
  // Sending JSON data (no need for FormData here since there's no file)
  return api.post('/api/experts/lawyer/onboard', data);
};